export default __webpack_public_path__ + "static/media/QK_9551.4a0c0e81.jpg";